import logo from './logo.svg';
import './App.css';
import './secondary-iran-sans.css';
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {useMutation} from "react-query";
import axios from "axios";
const url = 'https://dl.zamineno.com/zamineno_1.0.apk';
function App() {
    let params = useParams();

    const {mutateAsync} = useMutation((data) => axios.post('https://api.zamineno.com/api/sabtnam', data, {
        headers: {
            Accept: 'application/json',

        }
    }))
    useEffect(() => {
        window.sessionStorage.setItem('namayande_id', params.id)
    }, [])

    const [link, setLink] = useState(0)
    const [called, setCalled] = useState(false);
    function checkMobile(e) {
        var mobile = e.target.value
        if (mobile.length > 0 && mobile.length < 11) {
            //alert('شماره موبایل باید 11 رقمی باشد')
            e.target.focus()
            return false;
        }
        if (mobile.length > 11) {
            //alert('شماره موبایل باید 11 رقمی باشد')
            e.target.value = e.target.value.substring(0, 11)
            return false;
        }
    }

    function doSubmit(e) {
        e.preventDefault()
        setCalled(true)
        var mobile = e.target.mobile.value;

        var name = e.target.name.value;
        var id = window.sessionStorage.getItem('namayande_id');
        var form = new FormData;
        form.append('mobile', mobile)
        form.append('name', name)
        form.append('namayande', id)
        mutateAsync(form).then(res => {
            console.log(res.data)
            setLink(1)
            setCalled(false)
        }).catch(er => {

            setLink(2)
            setCalled(false)
        })
    }

    return (
        <>

            <body dir="rtl">
            <div className=" min-h-full flex flex-col items-center justify-center py-12 sm:px-6 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-md">
                    <img
                        className="mx-auto h-12 w-auto"
                        src='./logo.png'
                        alt="Workflow"
                    />
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">ثبت نام در زمین نو</h2>
                    <p className="mt-2 text-center text-sm text-gray-600">

                    </p>
                </div>

                <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                    <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                        {link == 1 ?
                            <div>
                                <h3 className='text-center'>ثبت نام شما در زمین نو انجام شد</h3>
                                <p>لطفا اپلیکیشن زمین نو رو از لینک زیر نصب نمایید</p>
                                <div className='text-center flex flex-col p-5'>
                                    <a className='p-5 font-large text-2xl'
                                       href={url}>
                                        <button className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-lg font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">دانلود
                                            فایل مستقیم
                                        </button>
                                    </a>

                                </div>
                            </div>
                            :
                            link == 2 ?
                                <div>
                                    <h3 className='text-center'>شما قبلا در زمین نو ثبت نام شده اید</h3>
                                    <p>لطفا اپلیکیشن زمین نو رو از لینک زیر نصب نمایید</p>
                                    <div className='text-center flex flex-col p-5'>
                                        <a className='p-5 font-large text-2xl'
                                           href={url}>
                                            <button className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-lg font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">دانلود
                                                فایل مستقیم
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                :
                                <form onSubmit={(e) => doSubmit(e)} className="space-y-6" action="" method="POST">
                                    <div>
                                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                            شماره موبایل
                                        </label>
                                        <div className="mt-1">
                                            <input
                                                id="email"
                                                name="mobile"
                                                type='mobile'
                                                onBlur={(e) => checkMobile(e)}
                                                required
                                                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                            نام
                                        </label>
                                        <div className="mt-1">
                                            <input
                                                id="password"
                                                name="name"
                                                type="text"

                                                required
                                                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                            />
                                        </div>
                                    </div>


                                    <div>
                                        {!called &&
                                        <button

                                            type="submit"
                                            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                        >
                                            ثبت نام
                                        </button>
}
                                    </div>
                                </form>
                        }

                    </div>
                </div>
            </div>
            </body>
        </>
    )
}

export default App;
